export function fileToNativeBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const filetypes = {
  excel: [
    ".xlsx",
    "application/excel",
    "application/vnd.ms-excel",
    "application/vnd.msexcel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],
  image: ["image/jpeg", "image/png"],
  pdf: ["application/pdf"],
};

export const convertFilelistToArray = (filelist: FileList): File[] => {
  const files: File[] = [];
  for (const file of filelist) {
    files.push(file);
  }
  return files;
};

export const formatBytes = (bytes: number): string => {
  const sizes = ["B", "KB", "MB", "GB", "TB"];

  if (bytes === 0) return "0 B";

  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);

  return `${value.toFixed(2)} ${sizes[i]}`;
};

export const getFileExtension = (filename: string): string => {
  return !filename.includes(".")
    ? ""
    : filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
};

export const removeFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return filename;
  } else {
    return filename.slice(0, lastDotIndex);
  }
};

export const fileSizes = {
  kilobyte: 1024,
  megabyte: 1024 * 1024,
  gigabyte: 1024 * 1024 * 1024,
};
export const defaultFileSize = {
  size: fileSizes.megabyte * 10,
  label: "10MB",
};

export function showDownloadBlockedWarning() {
  useNuxtApp().$toast("Permita os pop-ups para ver o arquivo!", {
    autoClose: 3000,
    type: "warning",
  });
}

/**
 * Downloads a file from a Blob with the specified filename
 * @param blob The Blob or Blob part to download
 * @param filename The name to give to the downloaded file
 * @param cleanup Whether to clean up the URL object after download (default: true)
 * @throws {Error} If there's an error during the download process
 */
export const downloadBlobFile = (
  blob: BlobPart,
  filename: string,
  cleanup = true
): void => {
  try {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    if (cleanup) {
      // Clean up resources after a short delay to ensure the download starts
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  } catch (error) {
    const errorMessage = `Falha ao baixar o arquivo: ${
      error instanceof Error ? error.message : "Erro desconhecido"
    }`;

    useNuxtApp().$error({
      error,
      message: errorMessage,
    });
    throw error;
  }
};

export const filterFilesByExtension = (
  files: File | File[],
  accept?: string[]
): File[] | undefined => {
  if (!accept) return Array.isArray(files) ? files : [files];
  else {
    if (Array.isArray(files)) {
      const validFiles = files.filter((file) => accept?.includes(file.type));
      return validFiles.length ? validFiles : undefined;
    } else {
      return accept.includes(files.type) ? [files] : undefined;
    }
  }
};
